import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { processSteps } from '@/mocks/site';

export default function Process() {
  return (
    <section className="relative overflow-hidden bg-primary-950 py-20 md:py-28">
      <div className="absolute inset-0 paper-grid-dark opacity-70" />
      <div
        className="pointer-events-none absolute -right-40 top-1/2 h-[520px] w-[520px] -translate-y-1/2 rounded-full opacity-30 blur-3xl"
        style={{ background: 'oklch(var(--accent-500) / 0.28)' }}
      />
      <div className="container-wide relative z-10">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <Reveal>
            <SectionHeading
              tone="dark"
              label="Notre méthode"
              title={
                <>
                  Du premier relevé
                  <br />
                  à la mise en service
                </>
              }
            />
          </Reveal>
          <Reveal delay={120}>
            <p className="text-base leading-relaxed text-background-300 lg:pb-3">
              Un projet industriel se joue sur les détails : un plan juste, un matériau adapté, une
              soudure maîtrisée. Nous séquençons chaque chantier en quatre étapes claires, avec un
              interlocuteur unique et une traçabilité complète.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-px bg-background-50/12 sm:grid-cols-2 lg:grid-cols-4">
          {processSteps.map((step, index) => (
            <Reveal key={step.number} delay={index * 110} className="bg-primary-950">
              <div className="group relative h-full px-6 py-8 transition-colors duration-500 hover:bg-background-50/5 md:px-7 md:py-10">
                <span className="font-heading text-6xl font-semibold leading-none text-accent-500/35 transition-colors duration-500 group-hover:text-accent-500">
                  {step.number}
                </span>
                <h3 className="mt-6 font-heading text-2xl font-semibold uppercase leading-tight text-background-50">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-background-300">{step.text}</p>
                <span className="absolute right-6 top-8 hidden h-2 w-2 bg-accent-500 md:block" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}